var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true*/

var is_node = typeof module == 'object' && module.exports && module.children;
if (is_node) ;else ;
define(['/www/hola/pub/util.js', 'cookie', '/www/hola/pub/gtm', '/www/hola/pub/experiment_util'], (www_util, cookie, gtm, experiment_util) => {
  var E = {};
  experiment_util = experiment_util.default;
  var plans_to_items = p => ({
    item_id: p.id,
    item_name: p.name,
    item_category: p.category,
    item_list_name: p.list,
    price: p.price
  });
  E.add_to_cart = plans => {
    var items = plans.map(plans_to_items);
    gtm.push({
      event: 'add_to_cart',
      ecommerce: {
        value: items[0].price,
        items,
        currency: 'USD'
      }
    });
    gtm.push({
      event: 'begin_checkout',
      ecommerce: {
        value: items[0].price,
        items,
        currency: 'USD'
      }
    });
  };
  E.view_item_list = plans => {
    var items = plans.map(plans_to_items);
    gtm.push({
      event: 'view_item_list',
      ecommerce: {
        items,
        currency: 'USD'
      }
    });
    gtm.push({
      event: 'view_item',
      ecommerce: {
        items,
        currency: 'USD'
      }
    });
  };
  var purchase = opt => {
    var transaction_id = opt.transaction_id,
      value = opt.value,
      plans = opt.plans;
    var items = plans.map(plans_to_items);
    gtm.push({
      event: 'purchase',
      ecommerce: {
        transaction_id,
        value,
        items,
        currency: 'USD'
      }
    });
  };
  E.send_after_payment_events = () => {
    www_util.perr({
      id: 'www_premium_payment_success'
    });
    var payment = cookie.getJSON('payment');
    if (payment) {
      www_util.perr({
        id: 'www_premium_get_payment_cookie',
        info: payment
      });
      var plans = [{
        id: payment.id,
        price: payment.price,
        category: 'vpn-b2c',
        name: payment.name,
        list: 'Plus page plans',
        quantity: 1
      }];
      www_util.check_tags(`www_premium_${location.pathname.slice(1)}`);
      gtm.push({
        provider: payment.provider
      });
      purchase({
        transaction_id: 'T' + Date.now() + payment.id,
        value: payment.price,
        plans
      });
      gtm.push({
        event: 'purchased'
      });
      cookie.remove('payment', {
        domain: '.hola.org',
        path: '/'
      });
    } else www_util.perr({
      id: 'www_premium_no_payment_cookie'
    });
  };
  return E;
});